import { useState, ReactNode } from 'react';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

const faqs = [
  {
    question: 'Как получить доступ к интернет-банкингу?',
    answer: (
      <div>
        Для подключения необходимо обратиться в офис банка. С собой нужно иметь:
        <ul className='list-disc pl-5 mt-2 flex flex-col gap-1'>
          <li>Официальное письмо о подключении к системе.</li>
          <li>Копии паспортов сотрудников, которых необходимо зарегистрировать в системе.</li>
        </ul>
        <span className='block mt-2'>
          На месте вы подписываете договор, подготовленный банком, после чего начинается процесс регистрации.
        </span>
      </div>
    ),
  },
  {
    question: 'Как подключить нового сотрудника?',
    answer:
      'Процедура аналогична первичному подключению: направляется официальное письмо от организации и предоставляется копия паспорта нового сотрудника. После этого подписываются необходимые документы в отделении банка.',
  },
  {
    question: 'Как получить ключи доступа?',
    answer: (
      <div>
        После регистрации данные направляются следующим образом:
        <ul className='list-disc pl-5 mt-2 flex flex-col gap-1'>
          <li>На электронную почту: приходят логин, временный пароль и ссылка для входа.</li>
          <li>На мобильный номер: дублируется только пароль в СМС-сообщении.</li>
        </ul>
      </div>
    ),
  },
  {
    question: 'Как сменить пароль?',
    answer:
      'Если вам необходимо изменить текущий пароль, вы можете обратиться по номеру 44 60 (техническая поддержка) или написать в чат поддержки напрямую из вашего личного кабинета.',
  },
  {
    question: 'Доступ неактивен, что делать?',
    answer:
      'Если при попытке входа вы видите сообщение о неактивности учетной записи, обратитесь в службу поддержки по номеру (44) 600-70-35 или воспользуйтесь внутренним чатом личного кабинета для выяснения причин и активации доступа.',
  },
  {
    question: 'Как сменить мобильный номер и почту?',
    answer:
      'Для изменения контактных данных (номера телефона или e-mail), привязанных к системе, необходимо направить в банк официальное письмо с указанием новых реквизитов.',
  },
  {
    question: 'Что делать, если не приходит СМС-подтверждение?',
    answer: (
      <ol className='list-decimal pl-5 flex flex-col gap-1'>
        <li>Проверьте наличие сети и качество мобильной связи.</li>
        <li>Проверьте папку «Спам» в вашей электронной почте (код может дублироваться туда).</li>
        <li>
          Если код так и не поступил, свяжитесь с нами по номеру (44) 600-70-35 или воспользуйтесь внутренним чатом
          личного кабинета.
        </li>
      </ol>
    ),
  },
  {
    question: 'Ошибка: «Пользователь не существует» — что это значит?',
    answer:
      'Данная ошибка означает, что логин введен неверно. Пожалуйста, проверьте правильность написания логина из письма, раскладку клавиатуры и отсутствие лишних пробелов.',
  },
  {
    question: 'Ошибка: «Представлены неправильные учетные данные для аутентификации» — что это значит?',
    answer:
      'Система распознала логин, но указывает на неправильно введенный пароль. Убедитесь, что вы вводите актуальный пароль, соблюдая регистр букв (заглавные/строчные).',
  },
  {
    question: 'Как связаться со службой поддержки «Ориён Бизнес»?',
    answer: (
      <div>
        Мы всегда на связи и готовы помочь вам:
        <ul className='list-disc pl-5 mt-2 flex flex-col gap-1'>
          <li>Телефон: позвоните нам по номеру (44) 600-70-35.</li>
          <li>Чат: напишите в онлайн-чат поддержки прямо в интерфейсе системы.</li>
        </ul>
      </div>
    ),
  },
];

type FaqItem = { question: string; answer: string | ReactNode };

function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <div className='flex justify-center'>
      <div className='lg:w-[1130px] w-full max-lg:px-4'>
        <div className='max-md:p-5 p-8 w-full bg-white mb-12' style={{ minHeight: 600 }}>
          <h1 className='text-2xl font-semibold text-gray-800 mb-8'>Часто задаваемые вопросы</h1>
          <div className='flex flex-col gap-3'>
            {(faqs as FaqItem[]).map((faq, index) => (
              <div key={index} className='border border-gray-200 rounded-xl overflow-hidden'>
                <button
                  onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                  className='w-full flex items-center justify-between px-6 py-4 bg-white border-0 cursor-pointer text-left hover:bg-gray-50 transition-colors duration-200'
                >
                  <span className='text-base font-medium text-gray-800'>{faq.question}</span>
                  {activeIndex === index ? (
                    <MinusOutlined className='text-[#ffb700] text-base flex-shrink-0' />
                  ) : (
                    <PlusOutlined className='text-[#ffb700] text-base flex-shrink-0' />
                  )}
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    activeIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className='px-8 py-4 text-sm text-gray-600 leading-relaxed'>{faq.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
